import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, onMounted, onUnmounted } from 'vue'

  import VideoPlayer from '@/components/VideoPlayer.vue'
  import SVGRenderer from '@/components/common/SVGRenderer.vue'
  import CourseDescription from '@/components/course/CourseDescription.vue'
  import KetchUpButton from '@/components/common/KetchUpButton.vue'
  import CourseModules from '@/components/course/CourseModules.vue'
  import AutoSlider from '@/components/common/AutoSlider.vue'

  import useCourse from '@/composables/useCourse'
  import useVideo from '@/composables/useVideo'
  import useIcons from '@/composables/useIcons'
  import useCommonMixin from '@/composables/useCommonMixin'
  import useShopifyClient from '@/composables/useShopifyClient'
  import useBreakpoint from '@/composables/useBreakpoint'

  import { UserModule } from '@/store/modules/user'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CourseDetailsModal',
  setup(__props) {

  const actionsWrapperRef = ref<HTMLElement | null>(null)
  const actionsWrapperHeight = ref(0)

  const { course, courseBundle, lessonsAndDuration, coursePurchasePerksToShow } = useCourse()
  const { getPosterImage } = useVideo()
  const { mediaIcon, teaserImage, arrowRightIndicator, textBlockIndicator } = useIcons()
  const { closeModal, inDevelopment } = useCommonMixin()
  const { createShopifyCheckout } = useShopifyClient()
  const { isSmallerMobileDevice, isDesktopDevice } = useBreakpoint()

  const reviewWidgetClass = computed(() => {
    if (!course.value?.title) return 'elfsight-app-cd80e849-640b-4cbe-991c-02cc8f205d19'

    const courseTitle = course.value.title

    switch (true) {
      case courseTitle.includes('34i'):
        return 'elfsight-app-bd270e0c-e68e-4f3e-b944-0ddb9bc00d44'
      case courseTitle.includes('34d'):
        return 'elfsight-app-103ff473-32e3-4013-b0ad-675fa6155510'
      case courseTitle.includes('34f'):
        return 'elfsight-app-fe2dfdad-d560-41c1-93e1-2ae5503a4a38'
      default:
        return 'elfsight-app-cd80e849-640b-4cbe-991c-02cc8f205d19'
    }
  })

  const buyNow = () => {
    createShopifyCheckout(UserModule.email || undefined, course.value?.shopifyProductVariantId)
  }

  const updateActionsWrapperHeight = () => {
    if (actionsWrapperRef.value) {
      actionsWrapperHeight.value = actionsWrapperRef.value.offsetHeight
    }
  }

  onMounted(() => {
    updateActionsWrapperHeight()
    window.addEventListener('resize', updateActionsWrapperHeight)
  })

  onUnmounted(() => {
    window.removeEventListener('resize', updateActionsWrapperHeight)
  })

return { __sfc: true,actionsWrapperRef, actionsWrapperHeight, course, courseBundle, lessonsAndDuration, coursePurchasePerksToShow, getPosterImage, mediaIcon, teaserImage, arrowRightIndicator, textBlockIndicator, closeModal, inDevelopment, createShopifyCheckout, isSmallerMobileDevice, isDesktopDevice, reviewWidgetClass, buyNow, updateActionsWrapperHeight, computed, ref, onMounted, onUnmounted, VideoPlayer, SVGRenderer, CourseDescription, KetchUpButton, CourseModules, AutoSlider, useCourse, useVideo, useIcons, useCommonMixin, useShopifyClient, useBreakpoint, UserModule }
}

})